import { render, staticRenderFns } from "./RadioBase.vue?vue&type=template&id=ff0b9354&scoped=true"
import script from "./RadioBase.vue?vue&type=script&lang=js"
export * from "./RadioBase.vue?vue&type=script&lang=js"
import style0 from "./RadioBase.vue?vue&type=style&index=0&id=ff0b9354&prod&lang=scss"
import style1 from "./RadioBase.vue?vue&type=style&index=1&id=ff0b9354&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0b9354",
  null
  
)

export default component.exports